import { all } from 'redux-saga/effects';

import oidcLoginSaga from './oidcLoginSaga';

const oidcSaga = function* rootSaga() {
  yield all([oidcLoginSaga()]);
};

export default oidcSaga;
